import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const GroupTitle = ({ title }: { title: ReactNode }) => {
  return (
    <Typography
      variant='overline'
      display='block'
      padding='8px 24px'
      marginY='12px'
      className='w-full cursor-default'
      sx={{
        backgroundColor: 'var(--mui-palette-background-tableHeader)',
      }}
    >
      {title}
    </Typography>
  );
};
